import { Component } from '@angular/core';

@Component({
    selector: 'i360-whole-page-error',
    template: `
        <div class="i360-warning">
            <i class="material-icons">error_outline</i>
            <p class="i360-warning-title">
                <ng-content select="[title]"></ng-content>
            </p>
            <p class="i360-warning-note">
                <ng-content select="[note]"></ng-content>
            </p>
        </div>`,
    styleUrls: ['./whole-page-error.component.scss'],
})
export class WholePageErrorComponent {}
